import React, { useState } from 'react'
import { Box } from '@mui/system'
import { Typography, Paper, Stack, Divider, CircularProgress } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar'
import { styled } from '@mui/material/styles'
import backgroundImage from '../../../assets/img/backgroundImage.svg'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined'
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt'
import { DataProps } from './interface'
import Blank from '../../Blank/Blank'
import { EmptyLength } from '../Main'
import { getPdf } from '../../../API/api'

export const Load = () => {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: '150px' }}>
			<CircularProgress />
		</Box>
	)
}

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
	borderRadius: `8px`,
	backgroundColor: '#e6e6e6',
	'&:before': {
		display: 'none',
	},
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({ theme }) => ({
	flexDirection: 'row-reverse',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(180deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	},
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderRadius: '8px',
}))

const drawerWidth = '50%'
// const Maina =
styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
	open?: boolean
}>(({ theme, open }) => ({
	flexGrow: 1,
	padding: theme.spacing(3),
	transition: theme.transitions.create('margin', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	marginRight: -drawerWidth,
	...(open && {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginRight: 0,
		borderRadius: '8px',
	}),
}))

interface AppBarProps extends MuiAppBarProps {
	open?: boolean
}
styled(MuiAppBar, {
	shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
	transition: theme.transitions.create(['margin', 'width'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	...(open && {
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['margin', 'width'], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginRight: drawerWidth,
	}),
}))

export const ControlledAccordions = ({ posts, loading }: DataProps) => {
	const [expanded, setExpanded] = useState<string | false>(false)
	const [selectedAccordion, setSelectedAccordion] = useState<string | null>(null)
	const [view, setView] = useState<boolean>(false)
	const [blankResult, setBlankResult] = useState<any>(null)
	const [colorItem, setColorItem] = useState<any>(null)
	const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
		if (newExpanded) {
			setColorItem(null)
		}
		
		setExpanded(newExpanded ? panel : false)
		setView(false)
	}

	if (loading) {
		<Load />
	}
	const handleAccordionClick = (accordionId: string) => {
		setSelectedAccordion(accordionId === selectedAccordion ? null : accordionId)
		setView(true)
	}

	const handleDownloadPDF = (fileName: string) => {
		const fetchPostAll = async () => {
			let pdfName = { data: { filename: fileName } }
			try {
				getPdf(pdfName).then((data) => {
					if (data.error) {
						return
					}
					if (!data.data) return

					const linkSource = `data:application/pdf;base64,${data.data}`
					const downloadLink = document.createElement('a')
					downloadLink.href = linkSource
					downloadLink.download = fileName
					downloadLink.click()
				})
			} catch (error) {
				console.error('Error fetching data:', error)
			}
		}
		fetchPostAll()
	}
	const openBlank = (number: string, results: any, name: string) => {
		setBlankResult(results)
		setColorItem(name)
	}

	return (
		<Box sx={{ mt: 1.5 }}>
			<Box sx={{ width:'100%', height: 30, bgcolor: 'primary.main', borderRadius: '8px', display:{sm:'block', xs:'none'} }}></Box>
			{/* minHeight={`calc(100vh - 272px)`} */}
			<Box sx={{ display: 'flex', flexDirection: 'row', mt: 3.125, minHeight:{sm: 'calc(100vh - 272px)', xs:'calc(100vh - 403px)'} }} >
				<Box width={'100%'}>
					{posts.length === 0 ? (
						<EmptyLength />
					) : (
						posts.map((post: any, idx: number) => {
							return (
								<Stack
									direction='row'
									divider={<Divider orientation='vertical' flexItem sx={{ borderRadius: '8px' }} />}
									spacing={2}
									key={idx}
									sx={{ borderRadius: '8px', margin: '3px' }}
								>
									<Accordion
										key={post.order_number}
										expanded={expanded === post.order_number}
										onChange={handleChange(post.order_number)}
										sx={{ width: '100%', bgcolor: '#DDDDDD', borderRadius: '8px' }}
									>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls={`${post.order_number}-content`}
											id={`${post.order_number}-header`}
											sx={{ backgroundColor: '#F4F1F4', borderRadius: '8px' }}
										>
											<Typography sx={{ flexShrink: 0, lineBreak: 'anywhere', width: '100%' }}>
												{post.date + ' ' + post.patient}
											</Typography>
											<Typography sx={{ color: 'text.secondary', lineBreak: 'anywhere' }}></Typography>
										</AccordionSummary>
										<AccordionDetails>
											<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
												<Typography
													onClick={() => handleAccordionClick(post.order_number)}
													sx={{
														width: '100%',
														cursor: 'pointer',
														textDecorationLine: 'underline ',
														fontWeight: '700',
													}}
												>
													{post.order_detail.map((e: any, idx: any) => {
														return (
															<Typography
																component={'span'}
																key={idx}
																onClick={() => openBlank(e.blank_id, e.results, e.blanc_name)}
																sx={{ width: 1, display: 'flex', justifyContent: 'space-between' }}
															>
																<Typography
																	component={'span'}
																	sx={{ color: e.blanc_name === colorItem ? 'red' : 'black' }}
																>
																	{e.blanc_name}
																</Typography>
																<Typography component={'span'}>
																	<CheckBoxOutlinedIcon sx={{ color: 'green' }} />
																	<SystemUpdateAltIcon
																		sx={{ color: 'primary.main' }}
																		onClick={() => handleDownloadPDF(e.file_name)}
																	/>
																</Typography>
															</Typography>
														)
													})}
												</Typography>
											</Box>
										</AccordionDetails>
									</Accordion>
								</Stack>
							)
						})
					)}
				</Box>
				{
					<Paper sx={{ display:{sm:'block', xs:'none'}, width: '100%', ml: 1.4, boxShadow: 'none', mb: 0, pb: 0 }}>
						<Box sx={{ textAlign: 'center', width: '100%', display: view ? 'none' : 'block' }}>
							<img src={backgroundImage} height='100%' alt='logo' />
						</Box>
						<Box sx={{ display: view ? 'block' : 'none' }}>
							<Blank post={posts} expend={expanded} blankresults={blankResult} />
						</Box>
					</Paper>
				}
			</Box>
		</Box>
	)
}
